import React from 'react';
import ReactDOM from 'react-dom';
import getRandomString from '@sportnet/utilities/getRandomString';
var MEDIAMANAGER_STYLES_ELEMNT_ID = 'mm-styles';
var MEDIAMANAGER_BASE_URL = 'https://mediamanager.sportnet.online';
var CLASS_NAME = "body-overflow-media-manager-connector";
var MEDIA_MNAGER_INSTANCE_PREFIX = 'media-manager-connector-placeholder-instance-';
var css = "\n.cms-connector-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 99998;\n}\n\n.cms-connector-iframe {\n  overflow: hidden;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 99999;\n}\n\n  [class*=\"".concat(CLASS_NAME, "\"]{\n    overflow: hidden;\n  }\n");
var getInitialInstanceId = function () {
    return "".concat(Date.now(), "-").concat(getRandomString(10));
};
export var MediaManagerConnector = function (_a) {
    var opened = _a.opened, appId = _a.appId, appSpace = _a.appSpace, onError = _a.onError, onUnauthorized = _a.onUnauthorized, onClose = _a.onClose, onSelectFiles = _a.onSelectFiles, _b = _a.useLastMM, useLastMM = _b === void 0 ? false : _b, _c = _a.mediaManagerBaseUrl, mediaManagerBaseUrl = _c === void 0 ? MEDIAMANAGER_BASE_URL : _c;
    var _d = React.useState(null), containerElement = _d[0], setContainerElement = _d[1];
    var iframeRef = React.useRef(null);
    var instanceId = React.useState(getInitialInstanceId)[0];
    var processSingleAlienMessage = React.useCallback(function (params) {
        var messageInstanceId = params.instanceId, type = params.type, payload = params.payload;
        if (instanceId !== messageInstanceId) {
            return;
        }
        var handleLoad = function () { };
        switch (type) {
            case 'MEDIAMANAGER_READY':
                handleLoad();
                break;
            case 'ERROR_GENERIC':
                if (typeof payload === 'string') {
                    if (onError) {
                        onError(payload);
                    }
                }
                else {
                    throw Error("Unexpected error \"".concat(payload, "\"."));
                }
                break;
            case 'ERROR_AUTH':
                if (onUnauthorized) {
                    onUnauthorized();
                }
                break;
            case 'CLOSE':
                if (onClose) {
                    onClose();
                }
                document.body.classList.remove("".concat(CLASS_NAME, "-").concat(instanceId));
                break;
            case 'FILES_SELECTED':
                if (onSelectFiles) {
                    onSelectFiles(payload);
                }
                break;
            default:
        }
    }, [instanceId, onSelectFiles, onClose, onUnauthorized, onError]);
    React.useEffect(function () {
        var containerElementId = "".concat(MEDIA_MNAGER_INSTANCE_PREFIX).concat(instanceId);
        var handleMessage = function (e) {
            if (mediaManagerBaseUrl === e.origin) {
                if (Array.isArray(e.data)) {
                    e.data.forEach(processSingleAlienMessage);
                }
            }
            else {
                console.warn("Message origin missmatch! (".concat(mediaManagerBaseUrl, " != ").concat(e.origin, ")"));
            }
        };
        if (opened) {
            var _containerElement = document.getElementById(containerElementId);
            if (!_containerElement) {
                var e = document.createElement('div');
                e.setAttribute('id', containerElementId);
                document.body.appendChild(e);
                setContainerElement(e);
            }
            var mmStylesElement = document.getElementById(MEDIAMANAGER_STYLES_ELEMNT_ID);
            if (!mmStylesElement) {
                var head = document.head || document.getElementsByTagName('head')[0];
                var style = document.createElement('style');
                style.id = MEDIAMANAGER_STYLES_ELEMNT_ID;
                if (style.sheet) {
                    style.sheet.replaceSync(css);
                }
                else {
                    style.appendChild(document.createTextNode(css));
                }
                head.appendChild(style);
                document.body.classList.add("".concat(CLASS_NAME, "-").concat(instanceId));
                window.addEventListener('message', handleMessage, false);
            }
        }
        else {
            var _containerElement = document.getElementById(containerElementId);
            if (_containerElement) {
                document.body.removeChild(_containerElement);
            }
            setContainerElement(null);
            var mmStylesElement = document.getElementById(MEDIAMANAGER_STYLES_ELEMNT_ID);
            if (mmStylesElement) {
                document.head.removeChild(mmStylesElement);
            }
            document.body.classList.remove("".concat(CLASS_NAME, "-").concat(instanceId));
            window.removeEventListener('message', handleMessage);
        }
        return function () {
            var _containerElement = document.getElementById(containerElementId);
            if (_containerElement) {
                document.body.removeChild(_containerElement);
            }
            var mmStylesElement = document.getElementById(MEDIAMANAGER_STYLES_ELEMNT_ID);
            if (mmStylesElement) {
                document.head.removeChild(mmStylesElement);
            }
            document.body.classList.remove("".concat(CLASS_NAME, "-").concat(instanceId));
            window.removeEventListener('message', handleMessage);
        };
    }, [opened, instanceId, processSingleAlienMessage, mediaManagerBaseUrl]);
    var getMediaManageIframeSrc = function () {
        var params = new URLSearchParams();
        params.set('instance_id', instanceId);
        params.set('useLastMM', String(useLastMM));
        params.set('fileSelection', String(!!onSelectFiles));
        return "".concat(mediaManagerBaseUrl, "/app/").concat(appId, "/").concat(appSpace, "?").concat(params.toString());
    };
    return opened && containerElement ? (React.createElement(React.Fragment, null, ReactDOM.createPortal(React.createElement(React.Fragment, null,
        React.createElement("div", { className: "cms-connector-backdrop" }),
        React.createElement("iframe", { ref: function (el) {
                iframeRef.current = el;
            }, style: {
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: 99999,
            }, title: "Media Manager", src: getMediaManageIframeSrc() })), containerElement, "media-manager-iframe-".concat(instanceId)))) : null;
};
